import { useEffect, useState } from "react";
import { db } from "../../../firebase";
import { useAuth } from "../../../hooks/useAuth";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";

export function useSavedRecommendations(gifteeId) {
  const { currentUser } = useAuth();
  const [savedRecommendations, setSavedRecommendations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser || !gifteeId) {
      setSavedRecommendations([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setSavedRecommendations([]);

    const col = collection(
      db,
      "users",
      currentUser.uid,
      "giftees",
      gifteeId,
      "savedRecommendations"
    );
    const q = query(col, orderBy("createdAt", "desc"));

    const unsub = onSnapshot(
      q,
      (snap) => {
        setSavedRecommendations(
          snap.docs.map((d) => ({ id: d.id, ...d.data() }))
        );
        setLoading(false);
      },
      (err) => {
        console.error("useSavedRecommendations error:", err);
        setLoading(false);
      }
    );

    return () => unsub();
  }, [currentUser, gifteeId]);

  return { savedRecommendations, loading };
}
